import { render, staticRenderFns } from "./couserViewnew.vue?vue&type=template&id=7d6452ae&scoped=true"
import script from "./couserViewnew.vue?vue&type=script&lang=js"
export * from "./couserViewnew.vue?vue&type=script&lang=js"
import style0 from "./couserViewnew.vue?vue&type=style&index=0&id=7d6452ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6452ae",
  null
  
)

export default component.exports